module.exports = __webpack_public_path__ + "static/media/CuramLife (2).a7477a8b.svg";